import React, { useEffect, useState, useContext } from "react";

import styled from "styled-components";
import { Bars } from "react-loader-spinner";

import { logout,
         getPaymentInformation,
         removeCards} from '../../utils/loginHelper';
import {PaymentContext} from '../../utils/paymentConfigProvider';
import eventBus  from '../../utils/globalPubSub';


const InfoTextSpan = styled.span`  
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  opacity: 0.45;
`


const InfoTextSpanMobile = styled.span`  
  font-family: 'IBM Plex Mono';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  opacity: 0.45;
`

const AddFundsButtonDiv =  styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 99px;
  height: 38px;
  background: rgba(255, 255, 255, 0.08);
  cursor: pointer;
`

const AddFundsButtonDivConnect =  styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 38px;
  background: rgba(255, 255, 255, 0.08);
  cursor: pointer;
`

const AddFundsButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
`

const CardNumberDiv = styled.div`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  display: flex;
  align-items: center;
  color: #FFFFFF;
`

const Mobile = styled.div`
  display: none;
  background: #000;
  padding-bottom: 0px;
  
  @media only screen and (max-device-width: 480px) {
  display: flex;
  /* height: 96vh; */
  flex-direction: row;
  }
`;

const Desktop = styled.div`
  display: none;
  background: #000;
  @media (min-device-width: 481px) {
  display: flex;
  flex-direction: column;
  /* height: 100vh; */
  height: 100%;
  /* overflow: hidden; */
  }
`;


export default function PaymentDetailsComponent(props:any){
    const [removeLoader, setRemoveLoader] = useState(false);
    const [paymentDetails, setPaymentDetails] = useState();

    const paymentConfig = useContext(PaymentContext);
    
    let isIndiaPayment = false;
    if(paymentConfig && paymentConfig.acceptedGateways){
        isIndiaPayment = (
            (paymentConfig.acceptedGateways.includes(
                'razorpay'))? true: false);
    }
    
    const removeAttachedPayment = async ()=>{        
        setRemoveLoader(true);
        window.analytics.track('card_detach_started', {
            type: 'web',
        });
        await removeCards();
        setRemoveLoader(false);
        window.analytics.track('card_detached', {
            type: 'web',
        });
    }

    useEffect(()=>{
        setPaymentDetails(getPaymentInformation());
    },[])

    useEffect(()=>{
        eventBus.on('payment-details-changed', (pd)=>{
            setPaymentDetails(pd);
        })
        return () => {
            eventBus.remove('payment-details-changed');
        }
    });

    if(isIndiaPayment){
        return (<></>);
    }
    
    return (
        <>
            {paymentDetails && (
                <>
                    <Desktop style={{marginTop: 37}}>
                        <InfoTextSpan>Payment Method
                        </InfoTextSpan>
                        <div style={{
                            marginTop: '14.5px',
                            display:'flex',
                            justifyContent:'space-between',
                            alignItems: 'center'
                        }}>
                        <CardNumberDiv>.... {paymentDetails.card.last4}</CardNumberDiv>
                        <AddFundsButtonDiv onClick={()=>{
                            removeAttachedPayment()}}>
                            {(!removeLoader) && (
		                <AddFundsButtonTextSpan>
			            DETACH
		                </AddFundsButtonTextSpan>
                            )}
                            {(removeLoader) && (
                                <Bars
                                    heigth="30" width="30"
                                    color="grey"
                                    ariaLabel="loading-indicator" />
                            )}
		        </AddFundsButtonDiv>
                        </div>
                    </Desktop>
                    <Mobile>
                        <div style={{display:'flex',
                                     justifyContent:'space-between',
                                     width:'100%',
                                     marginTop:17
                        }}>
                            <div style={{display:'flex', flexDirection:'column'}}>
                            <InfoTextSpanMobile>Payment Method</InfoTextSpanMobile>
                            <CardNumberDiv style={{marginTop: 6}}>.... {paymentDetails.card.last4}</CardNumberDiv>
                        </div>
                            <div style={{
                                display:'flex',
                                justifyContent:'space-between',
                                alignItems: 'center'
                        }}>
                            <AddFundsButtonDiv onClick={()=>{
                                removeAttachedPayment()}}>
                                {(!removeLoader) && (
		                    <AddFundsButtonTextSpan>
			                    DETACH
		                    </AddFundsButtonTextSpan>
                                )}
                                {(removeLoader) && (
                                    <Bars
                                        heigth="30" width="30"
                                        color="grey"
                                        ariaLabel="loading-indicator" />
                                    )}
		            </AddFundsButtonDiv>
                            </div>
                        </div>
                    </Mobile>
        </>
            )}
        {!paymentDetails && (
	    <div>
		<AddFundsButtonDivConnect style={{marginTop: 20}} onClick={
                ()=>{props.openAddPaymentsDiv()}}>
		    <AddFundsButtonTextSpan>
			CONNECT CREDIT/DEBIT CARD
		    </AddFundsButtonTextSpan>
		</AddFundsButtonDivConnect>
	    </div>
        )}
        </>
    )
}
